var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('search-bar')],1),(_vm.result && _vm.isfound)?_c('div',[_vm._v(_vm._s(_vm.prodis))]):_vm._e(),(_vm.result && _vm.isfound)?_c('div',[_c('navigation-bar')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }